import Userback, { UserbackWidget } from "@userback/widget";
import { useEffect } from "react";
import { asyncVoid } from "utils/asyncVoidHandler";
import type { CurrentBrandData, CurrentUserData } from "utils/currentUserHooks";

const USERBACK_TOKEN = "A-nKygXd5cQhMtRlYagmHhLR2SP";

let userbackPromise: Promise<UserbackWidget> | undefined;

function getUserbackPromise() {
  if (typeof window === "undefined") return;
  if (userbackPromise) return userbackPromise;
  userbackPromise = Userback(USERBACK_TOKEN, {
    /* eslint-disable @typescript-eslint/naming-convention */
    widget_settings: {
      trigger_type: "api",
    },
    /* eslint-enable @typescript-eslint/naming-convention */
  });
  return userbackPromise;
}

export async function setCurrentBrand(brandData: CurrentBrandData | null) {
  const userback = await getUserbackPromise();

  if (!userback) return;

  userback.setData({
    currentBrandId: brandData?.id,
    currentBrandName: brandData?.name,
  });
}

export async function setCurrentUser(
  userData: CurrentUserData | null,
  brandData?: CurrentBrandData | null,
) {
  const userback = await getUserbackPromise();

  if (!userback) return;

  if (userData?.id) {
    userback.identify(userData.id, {
      email: userData.email,
      name: `${userData.firstName || ""} ${userData.lastName || ""}`.trim(),
    });
  } else {
    userback.identify("", {});
  }

  if (brandData !== undefined) {
    await setCurrentBrand(brandData);
  }
}

export async function openFeedbackForm() {
  const userback = await getUserbackPromise();
  if (!userback) return;
  return userback.openForm();
}

export async function clearCurrentUser() {
  const userback = await getUserbackPromise();
  if (!userback) return;
  return setCurrentUser(null, null);
}

export function useInitUserback() {
  useEffect(() => {
    const promise = getUserbackPromise();
    if (promise) asyncVoid(promise);
  }, []);
}
